import React from 'react';
import {ImageUploader} from '../uploaders';
import LayerData from './layer-data';
import './stage-editor.css';

/** @class PatternLayerData
 * A component for editing pattern layer-specific properties.
 * @prop {string} name - the name of the layer
 * @prop {url} image - the url of the image to load
 */
export default class PatternLayerData extends LayerData {
  /** @function render
    * Renders the component.
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Pattern Layer</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text" name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <ImageUploader
            name="Image"
            value={this.state.image}
            dataURL={this.props.dataURL}
            onUpload={(url) => this.handleImageUpload("image", url)}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stage-editor/pattern-layer-data.js